package org.braunequip.web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.styles.toSitePalette
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.*

@Page(routeOverride = "contactus")
@Composable
fun ContactUsPage() {
    val sitePalette = ColorMode.current.toSitePalette() //Not needed yet, need to set values in SiteTheme.kt
    val context = rememberPageContext()

    PageLayout("Contact Us") {
        Section(Modifier.classNames("hero").backgroundColor(Colors.WhiteSmoke).toAttrs()) {
            Div(Modifier.classNames("container", "is-widescreen").toAttrs()) {
                Div(Modifier.classNames("hero-body", "has-text-centered").toAttrs()) {
                    H1(Modifier.classNames("title", "is-1", "has-text-black").toAttrs()) { Text("CONTACT US") }
                    P(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("subtitle", "is-3").toAttrs()) { Text("Reach Out To Braun Equipment Staff") }
                }
            }
        }

        Section(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("section").toAttrs()) {
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {
                Div(Modifier.classNames("columns").toAttrs()) {

                    Div(Modifier.classNames("column").toAttrs()) {
                        Div(Modifier.classNames("block").toAttrs()) {
                            H3(Modifier.classNames("title", "is-5", "has-text-dark").toAttrs()) {
                                Text("Ryan Braun - Owner")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Phone: 530-214-7533")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Email: braunequipment@yahoo.com")
                            }
                        }

                        Div(Modifier.classNames("block").toAttrs()) {
                            H3(Modifier.classNames("title", "is-5", "has-text-dark").toAttrs()) {
                                Text("Gabe Singewald - Owner")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Phone: 530-214-7533")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Email: braunequipment@yahoo.com")
                            }
                        }

                        Div(Modifier.classNames("block").toAttrs()) {
                            H3(Modifier.classNames("title", "is-5", "has-text-dark").toAttrs()) {
                                Text("Travis Smith - Chief Financial Officer")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Accounts Payables and Receivables")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Phone: 530-214-7533")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Email: braunequipment@yahoo.com")
                            }
                        }

                        Div(Modifier.classNames("block").toAttrs()) {
                            H3(Modifier.classNames("title", "is-5", "has-text-dark").toAttrs()) {
                                Text("Mary Briggs - Brokering/Dispatch")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Phone: 530-214-7533")
                            }
                            P(Modifier.classNames("is-6").toAttrs()) {
                                Text("Email: braunequipment@yahoo.com")
                            }
                        }
                    }

                    Div(Modifier.classNames("column").toAttrs()) {
                        Div(Modifier.classNames("block").toAttrs()) {
                            Img(
                                attrs = Modifier
                                    .width(100.percent).height(autoLength)
                                    .toAttrs(),
                                src = "braunequiplogo.png"
                            )
                        }
                        Div(Modifier.classNames("block").toAttrs()) {
                            P(Modifier.classNames("is-size-5", "has-text-dark").toAttrs()) {
                                Text("Office: 3660 Suite C Mainstreet, Cottonwood CA 96022")
                            }
                            P(Modifier.classNames("is-size-5", "mt-5", "has-text-dark").toAttrs()) {
                                Text("Mailing: PO Box 1269, Red Bluff CA 96080")
                            }
                        }
                    }



                }
            }
        }
    }
}

